import BaseSidebar from './../BaseSidebar';

class LeftSidebar extends BaseSidebar {

	get className() {
		return "page-layout left-sidebar";
	}

}

export default LeftSidebar;